import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import Icon from '@material-ui/core/Icon';
import Grid from '@material-ui/core/Grid';
import { Divider } from '@material-ui/core';
import { useClinic } from '../../../model/hooks/clinic/ClinicHooks';
import { useClinicUser } from '../../../model/hooks/clinic/ClinicUserHooks';
import { PageTitle, SecondaryButton, PaperWithTitle, RateWithNumber, LinkText } from '../../components';
import * as Constants from '../../common/constants';
import { Utils } from '../../../common/helper';
import { isUnregisteredUser } from '../../common/helper';
export const Home = () => {
    const { t } = useTranslation();
    const history = useHistory();
    const { jobClinic, paymentClinic } = useClinicUser();
    const { loadClinicCounter } = useClinic();
    const onClickRouteButton = (path) => (path ? history.push(path) : undefined);
    const [reviewAve, setReviewAve] = useState(0.0);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        const f = async () => {
            try {
                const clinicCounter = await loadClinicCounter(jobClinic.id);
                if (Utils.isNotNull(clinicCounter)) {
                    setReviewAve(clinicCounter.reviewRatingAveValue);
                }
            }
            catch (e) {
                console.error(e);
            }
            setLoading(false);
        };
        if (Utils.isNotNull(jobClinic)) {
            f();
        }
    }, [jobClinic]);
    return (React.createElement(React.Fragment, null,
        React.createElement(PageTitle, null, t('ホーム')),
        React.createElement(SButtonArea, null,
            React.createElement(Grid, { container: true, spacing: 2 },
                isUnregisteredUser(paymentClinic) && (React.createElement(Grid, { item: true, sm: 12 },
                    React.createElement(PaperWithTitle, { title: "\u6C42\u4EBA\u63B2\u8F09\u307E\u3067\u306E\u6D41\u308C", titleIcon: "check" },
                        React.createElement(SStepContainer, null,
                            React.createElement(LinkText, { size: "16px", marginLeft: "16px", onClick: () => history.push('/home/account/change_creditcard') }, "\uFF11\u3001\u30AF\u30EC\u30B8\u30C3\u30C8\u30AB\u30FC\u30C9\u767B\u9332"),
                            React.createElement(SStepContent, null, "\u30A2\u30AB\u30A6\u30F3\u30C8\u60C5\u5831\u306E[\u30AF\u30EC\u30B8\u30C3\u30C8\u30AB\u30FC\u30C9\u767B\u9332]\u30DC\u30BF\u30F3\u304B\u3089\u30AF\u30EC\u30B8\u30C3\u30C8\u30AB\u30FC\u30C9\u3092\u767B\u9332\u3057\u3066\u304F\u3060\u3055\u3044\u3002"),
                            React.createElement(SDivider, null),
                            React.createElement(LinkText, { size: "16px", marginLeft: "16px", onClick: () => history.push('/home/account/change_plan') }, "\uFF12\u3001\u3054\u5951\u7D04\u30D7\u30E9\u30F3\u306E\u767B\u9332"),
                            React.createElement(SStepContent, null, "\u30A2\u30AB\u30A6\u30F3\u30C8\u60C5\u5831\u306E\u3054\u5951\u7D04\u30D7\u30E9\u30F3\u306E[\u5909\u66F4\u3059\u308B]\u30DC\u30BF\u30F3\u304B\u3089\u3054\u5229\u7528\u306E\u30D7\u30E9\u30F3\u3092\u767B\u9332\u3057\u3066\u304F\u3060\u3055\u3044\u3002"),
                            React.createElement(SDivider, null),
                            React.createElement(LinkText, { size: "16px", marginLeft: "16px", onClick: () => history.push('/home/job_offer') }, "\uFF13\u3001\u6C42\u4EBA\u63B2\u8F09\u958B\u59CB"),
                            React.createElement(SStepContent, null, "\u6C42\u4EBA\u7BA1\u7406\u306E[\u65B0\u898F\u4F5C\u6210]\u30DC\u30BF\u30F3\u304B\u3089\u6C42\u4EBA\u5185\u5BB9\u3092\u5165\u529B\u3057\u3001\u63B2\u8F09\u3092\u958B\u59CB\u3057\u307E\u3057\u3087\u3046\uFF01"))))),
                React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                    React.createElement(SecondaryButton, { fullWidth: true, size: "large", onClick: () => onClickRouteButton(Constants.MENU[1].path) },
                        React.createElement(SLabelContainer, null,
                            React.createElement(SIcon, null, Constants.MENU[1].icon),
                            t(Constants.MENU[1].title)))),
                React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                    React.createElement(SecondaryButton, { fullWidth: true, size: "large", onClick: () => onClickRouteButton(Constants.MENU[2].path) },
                        React.createElement(SLabelContainer, null,
                            React.createElement(SIcon, null, Constants.MENU[2].icon),
                            t(Constants.MENU[2].title)))),
                React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                    React.createElement(SecondaryButton, { fullWidth: true, size: "large", onClick: () => onClickRouteButton(Constants.MENU[3].path) },
                        React.createElement(SLabelContainer, null,
                            React.createElement(SIcon, null, Constants.MENU[3].icon),
                            t(Constants.MENU[3].title)))),
                React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                    React.createElement(SecondaryButton, { fullWidth: true, size: "large", onClick: () => onClickRouteButton(Constants.MENU[4].path) },
                        React.createElement(SLabelContainer, null,
                            React.createElement(SIcon, null, Constants.MENU[4].icon),
                            t(Constants.MENU[4].title)))))),
        React.createElement(Grid, { container: true, spacing: 2 },
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(PaperWithTitle, { title: "\u5E73\u5747\u8A55\u4FA1", titleIcon: "star" },
                    React.createElement(SPaperContentArea, null, !loading && React.createElement(RateWithNumber, { value: reviewAve, size: "large" })))))));
};
const SButtonArea = styled.div `
  padding-top: 32px;
  padding-bottom: 32px;
`;
const SLabelContainer = styled.span `
  display: flex;
  align-items: center;
  padding-top: 8px;
  padding-bottom: 8px;
`;
const SIcon = styled(Icon) `
  margin-right: 8px;
`;
const SPaperContentArea = styled.div `
  height: 160px;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
`;
const SStepContainer = styled.span `
  padding: 16px;
`;
const SStepContent = styled.p `
  margin-left: 32px;
  margin-top: 8px;
`;
const SDivider = styled(Divider) `
  &&& {
    margin-bottom: 16px;
  }
`;
// const SNumber = styled.p`
//   margin: 0;
//   font-size: 40px;
//   font-weight: bold;
//   font-family: Roboto;
// `
